const useRestaurantCodes = () => {
    // Matching src/App.tsx:44 /:codeSite/:codeTable before router init
    const matches = window.location.pathname.match(/\/(?<codeSite>\d+)\/(?<codeTable>\d+)/)
    const { codeSite, codeTable } = matches?.groups ?? {}

    return { codeSite, codeTable }
}

export default useRestaurantCodes
